// extracted by mini-css-extract-plugin
module.exports = {"link":"style_link__QUdYw","indicator":"style_indicator__TXMRG"};